var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/certificates","title":"Lista certyfikatów","numeral_text":['certyfikat', 'certyfikaty', 'certyfikatów'],"columns_title":['name', 'icon']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }